import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const DashCardActionButtonsContainer = styled.span`
  display: flex;
  align-items: center;
  color: ${color("text-medium")};
  line-height: 1px;
  gap: 0.5rem;
`;
